/* Style by Clariss — productpagina: hoeveelheidsvoordeel, knopprijs, cadeauverpakking, 'Maak de look compleet', setblok. */
(function () {
  const money = (cents) => {
    const fmt = window.sbcMoneyFormat || '€{{amount_with_comma_separator}}';
    const amount = (cents / 100).toFixed(2);
    const [int, dec] = amount.split('.');
    const withComma = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  const info = document.querySelector('product-info');
  if (!info) return;
  const qtyInput = () => info.querySelector('input[name="quantity"]');
  const btnPrice = () => info.querySelector('[data-sbc-btn-price]');
  const tiersBox = () => info.querySelector('[data-sbc-tiers]');
  const gift = () => info.querySelector('[data-sbc-pdp-giftwrap]');

  let basePrice = Number(tiersBox()?.dataset.basePrice || info.querySelector('[data-selected-price-amount]')?.dataset.selectedPriceAmount * 100 || 0);
  let pct = 0;

  function currentQty() {
    return Math.max(1, Number(qtyInput()?.value || 1));
  }

  function render() {
    const qty = currentQty();
    const box = tiersBox();
    if (box) {
      box.querySelectorAll('[data-sbc-tier]').forEach((t) => {
        const tq = Number(t.dataset.qty), tp = Number(t.dataset.pct);
        const full = basePrice * tq;
        const total = Math.round((full * (100 - tp)) / 100);
        const f = t.querySelector('[data-sbc-tier-full]');
        if (f) f.textContent = money(full);
        t.querySelector('[data-sbc-tier-total]').textContent = money(total);
        t.setAttribute('aria-checked', String(tq === qty));
        if (tq === qty) pct = tp;
      });
      if (![...box.querySelectorAll('[data-sbc-tier]')].some((t) => Number(t.dataset.qty) === qty)) pct = 0;
    }
    const g = gift();
    const extra = g && g.checked ? Number(g.dataset.price || 0) : 0;
    const total = Math.round((basePrice * qty * (100 - pct)) / 100) + extra;
    const bp = btnPrice();
    if (bp && basePrice > 0) bp.textContent = ' · ' + money(total);
    const sp = info.querySelector('[data-sbc-sticky-price]');
    if (sp && basePrice > 0) sp.textContent = money(total);
  }

  // Tier-klik → aantal zetten
  info.addEventListener('click', (e) => {
    const t = e.target.closest('[data-sbc-tier]');
    if (!t) return;
    const q = qtyInput();
    if (q) {
      q.value = t.dataset.qty;
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }
    render();
  });
  info.addEventListener('change', (e) => {
    if (e.target.matches('input[name="quantity"], [data-sbc-pdp-giftwrap]')) render();
  });
  info.addEventListener('input', (e) => {
    if (e.target.matches('input[name="quantity"]')) render();
  });

  // Variantwissel (Dawn pub/sub)
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const v = event?.data?.variant;
      if (v && typeof v.price === 'number') {
        basePrice = v.price;
        const box = tiersBox();
        if (box) box.dataset.basePrice = v.price;
        render();
      }
    });
    // Na toevoegen vanuit het productformulier: cadeauverpakking meesturen als het vinkje aanstaat
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (event?.source !== 'product-form') return;
      const g = gift();
      if (!g || !g.checked) return;
      try {
        const cart = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
        const already = cart.items.some((i) => String(i.variant_id) === String(g.dataset.variantId));
        if (already) return;
        const res = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(g.dataset.variantId), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
        }).then((r) => r.json());
        const d = document.querySelector('cart-drawer');
        if (d && res.sections) { d.classList.remove('is-empty'); d.renderContents(res); }
      } catch (err) {
        console.warn('[sbc] cadeauverpakking', err);
      }
    });
  }

  // 'Maak de look compleet' en setblok: selectie + totaal + alles-in-één toevoegen
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-sbc-combo]');
    if (!box || !e.target.matches('[data-sbc-combo-item]')) return;
    const picked = [...box.querySelectorAll('[data-sbc-combo-item]:checked')];
    const extra = picked.reduce((s, i) => s + Number(i.dataset.price), 0);
    const total = Math.round((basePrice * currentQty() * (100 - pct)) / 100) + extra;
    const btn = box.querySelector('[data-sbc-combo-add]');
    if (btn) {
      btn.disabled = picked.length === 0;
      const t = btn.querySelector('[data-sbc-combo-total]');
      if (t) t.textContent = picked.length ? ' · ' + money(total) : '';
    }
  });
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-sbc-combo-add]');
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-sbc-combo]');
    const items = [...box.querySelectorAll('[data-sbc-combo-item]:checked')].map((i) => ({ id: Number(i.dataset.variantId), quantity: 1 }));
    const mainId = Number(info.querySelector('input.product-variant-id')?.value);
    if (box.dataset.includeMain !== 'false' && mainId) items.unshift({ id: mainId, quantity: currentQty() });
    if (!items.length) return;
    btn.disabled = true;
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      }).then((r) => r.json());
      const d = document.querySelector('cart-drawer');
      if (d && res.sections) { d.classList.remove('is-empty'); d.renderContents(res); }
    } finally {
      btn.disabled = false;
    }
  });

  // Complementaire producten voor 'Maak de look compleet' ophalen
  document.querySelectorAll('[data-sbc-complete-look]').forEach((el) => {
    const url = `${el.dataset.url}?section_id=${el.dataset.sectionId}&product_id=${el.dataset.productId}&intent=complementary&limit=${el.dataset.limit || 3}`;
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sbc-complete-look]');
        if (fresh && fresh.dataset.count !== '0' && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else if (!el.innerHTML.trim()) el.closest('.shopify-section')?.classList.add('sbc-hidden');
      })
      .catch(() => {});
  });

  // Sticky koopbalk op mobiel zodra de echte knop uit beeld is
  const sticky = info.querySelector('[data-sbc-sticky-buy]');
  const mainBtn = info.querySelector('.product-form__submit');
  if (sticky && mainBtn) {
    let ticking = false;
    const updateSticky = () => {
      ticking = false;
      const show = mainBtn.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelector('button').tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); } }, { passive: true });
    updateSticky();
  }

  // USP's op mobiel: één regel die elke 3 s wisselt
  const uspList = info.querySelector('.sbc-usps');
  if (uspList && uspList.children.length > 1) {
    let idx = 0;
    const items = [...uspList.children];
    items[0].classList.add('is-active');
    setInterval(() => {
      if (window.innerWidth >= 750) return;
      items[idx].classList.remove('is-active');
      idx = (idx + 1) % items.length;
      items[idx].classList.add('is-active');
    }, 3000);
  }

  // Aantal en verlanglijst-hartje in dezelfde rij als de koopknop
  const buyRow = info.querySelector('.product-form__buttons');
  const qtyBox = info.querySelector('.product-form__quantity');
  const wishBlock = [...info.querySelectorAll('.product__info-container > .shopify-block')].find((b) => b.id.includes('wishlist') || b.querySelector('[class*="wk-"]'));
  if (buyRow && qtyBox) buyRow.prepend(qtyBox);
  if (buyRow && wishBlock) buyRow.append(wishBlock);

  render();
})();
